export function getFilenameFromContentDisposition(cd: string | null): string | undefined {
  if (!cd) return undefined

  // filename*=UTF-8''something%20cool.pdf
  const star = cd.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim())
    } catch {
      return star[1].trim()
    }
  }

  // filename="something.pdf"
  const quoted = cd.match(/filename\s*=\s*"([^"]+)"/i)
  if (quoted?.[1]) return quoted[1].trim()

  // filename=something.pdf
  const plain = cd.match(/filename\s*=\s*([^;]+)/i)
  if (plain?.[1]) return plain[1].trim()

  return undefined
}
